import { useEffect, useState } from 'react'
import { pushHinweisText } from '../erinnerungen'
import { pushHinweisArt, type PushHinweisArt } from '../push'

/** Zeigt, warum dieses Gerät eine Erinnerung nicht melden würde, mit Weg zur Einstellung; sonst nichts. */
export function PushHinweis() {
  const [art, setArt] = useState<PushHinweisArt | null>(null)
  useEffect(() => {
    pushHinweisArt().then(setArt).catch(() => setArt(null))
  }, [])
  if (!art) return null
  return (
    <p className="hinweis">
      {pushHinweisText(art)}
      {art === 'aus' && (
        <>
          {' '}
          <a href="#konto">Einschalten unter Konto → Benachrichtigungen</a>
        </>
      )}
    </p>
  )
}
